// Angular
import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
// External
import * as moment from 'moment';
import * as Pikaday from 'pikaday';

@Component({
    selector: 'app-date-time-picker',
    templateUrl: './date-time-picker.component.html',
    styleUrls: ['./date-time-picker.component.scss']
})

export class DateTimePickerComponent implements OnInit, OnChanges {

    @ViewChild('date') dateInput: ElementRef;

    @Input() label: string;
    @Input() minDate: Date;
    @Output() onChange: EventEmitter<number>;

    public hour: string;
    public hours: Array<string>;
    public minute: string;
    public minutes: Array<string>;

    private picker: Pikaday;

    constructor() {
        this.minDate = moment().toDate();
        this.onChange = new EventEmitter();

        this.hour = '00';
        this.hours = [];
        for (let i = 0; i < 24; i++) {
            if (i < 10) {
                this.hours.push(`0${i}`);
            } else {
                this.hours.push(`${i}`);
            }
        }

        this.minute = '00';
        this.minutes = [];
        for (let i = 0; i < 60; i++) {
            if (i < 10) {
                this.minutes.push(`0${i}`);
            } else {
                this.minutes.push(`${i}`);
            }
        }
    }

    ngOnInit() {
        this.picker = new Pikaday({
            field: this.dateInput.nativeElement,
            minDate: this.minDate,
            onSelect: () => {
                this.setMinHours();
                this.setMinMinutes();
                this.getDateTime();
            }
        });
    }

    ngOnChanges() {
        if (this.picker && this.minDate) {
            this.setMinHours();
            this.setMinMinutes();
            this.setMinDays();
            this.picker.setMinDate(moment(this.minDate).toDate());
        }
    }

    getDiffDays(): number {
        const date = moment(this.picker.getDate()).format('DD-MM-YYYY');
        const minDate = moment(this.minDate).format('DD-MM-YYYY');
        return moment(date, 'DD-MM-YYYY').diff(moment(minDate, 'DD-MM-YYYY'), 'days');
    }

    getDiffHours(): number {
        const selectHour = parseInt(this.hour);
        const minHour = moment(this.minDate).hours();
        return selectHour - minHour;
    }

    setMinDays() {
        if (this.getDiffDays() < 0) {
            this.picker.setDate(moment(this.minDate).toDate());
        }
    }

    setMinHours() {
        if (!this.picker.getDate()) {
            return;
        }

        let minHours = moment(this.minDate).hours();

        if (this.getDiffDays()) {
            minHours = 0;
        } else {
            this.hour = `${minHours}`;

            if (minHours < 10) {
                this.hour = `0${minHours}`;
            }
        }

        this.hours = [];
        for (let i = minHours; i < 24; i++) {
            if (i < 10) {
                this.hours.push(`0${i}`);
            } else {
                this.hours.push(`${i}`);
            }
        }
    }

    setMinMinutes() {
        if (!this.picker.getDate()) {
            return;
        }

        let minMinutes = moment(this.minDate).minutes();

        if (this.getDiffDays() || this.getDiffHours()) {
            minMinutes = 0;
        } else {
            this.minute = `${minMinutes}`;

            if (minMinutes < 10) {
                this.minute = `0${minMinutes}`;
            }
        }

        this.minutes = [];
        for (let i = minMinutes; i < 60; i++) {
            if (i < 10) {
                this.minutes.push(`0${i}`);
            } else {
                this.minutes.push(`${i}`);
            }
        }
    }

    changeHour() {
        this.getDateTime();
        this.setMinMinutes();
    }

    changeMinute() {
        this.getDateTime();
    }

    getDateTime() {
        const date = moment(this.minDate).format('DD-MM-YYYY');
        const dateTime = moment(`${date} ${this.hour}:${this.minute}`, 'DD-MM-YYYY HH:mm');

        this.onChange.emit(dateTime.unix());
    }
}
